import { render, staticRenderFns } from "./EditCardActions.vue?vue&type=template&id=2a87040e&"
import script from "./EditCardActions.vue?vue&type=script&lang=ts&"
export * from "./EditCardActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports